import { labels } from './sendings'

export default {
  title: 'Fallbacks',

  labels,

  errors: {
    onTimeout: {
      timeout: 'Cannot be less than 10'
    }
  }
}
